<template>
  <div v-if="isMyAccount || !dummy">
    <TextLabel class="">{{ label }}</TextLabel>
    <div v-if="dummy" class="row">
      <div class="col">
        <!-- {{ dummy }}&nbsp; -->
        <template v-if="isMyAccount && permissions.createTournament">
          <router-link
            class="purple-link"
            :to="{
              name: $routerNames.EDIT,
              params: account.params,
              hash: '#social-links-edit',
            }"
            >{{
              $t('_web_profile-info_linked-accounts-add-link', 'Link accounts')
            }}</router-link
          >
        </template>
      </div>
    </div>
    <div v-else class="row no-gutters">
      <a
        v-for="(social, index) in accountSocials"
        :key="`social_${social}_${index}`"
        :href="getSocialLink(social.name, social.login)"
        target="_blank"
        class="col-auto px-0 h-mr-4"
      >
        <SocialIcon
          :key="`social_${social}_${index}_icon`"
          :name="`${social.name}`"
          :size="24"
        />
      </a>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import TextLabel from '@/components/atoms/TextLabel';
import SocialIcon from '@/components/images/Social';
import { getSocialLink } from '@/constants/social';

export default {
  name: 'AccountInfoSocials',
  components: {
    SocialIcon,
    TextLabel,
  },
  computed: {
    ...mapState('current', ['account', 'accountId']),
    ...mapState('my', { myAccountId: 'accountId' }),
    ...mapGetters(['permissions']),
    label() {
      return this.$t('_web_profile-info_linked-accounts', 'Social');
    },
    isMyAccount() {
      return this.accountId === this.myAccountId;
    },
    accountSocials() {
      return Object.entries(this.account.social || {}).reduce(
        (acc, [name, login]) => {
          if (login) {
            acc.push({ name, login });
          }
          return acc;
        },
        []
      );
    },
    dummy() {
      return this.accountSocials.length
        ? null
        : this.isMyAccount
        ? this.$t(
            '_web_profile-info_no-accounts_my',
            "You haven't linked your accounts yet. Go to edit mode to do that"
          )
        : this.$t(
            '_web_profile-info_no-accounts',
            "User hasn't linked any account yet"
          );
    },
  },
  methods: {
    getSocialLink,
  },
};
</script>

<style lang="scss">
.purple-link {
  color: #5a58f2 !important;
  &:hover {
    color: #5a58f2;
    opacity: 0.8;
  }
}
</style>
